import { render } from "./ParagraphStyle.vue?vue&type=template&id=6168b162&ts=true"
import script from "./ParagraphStyle.vue?vue&type=script&lang=ts"
export * from "./ParagraphStyle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__